<template>
    <div>
        <table-actions-menu
                position="table-action-menu--low-and-right"
                width="table-action-menu--only-one">
            <delete-button
                    :url="route('tenantapi.users.usergroups.destroy', {user_group: data.id, user: user.id})"
                    :confirmTitle="this.trans('users.note.unassign_usergroup_title')"
                    :confirmText="this.trans('users.note.unassign_usergroup_message')"
                    :errorFlashMessage="this.trans('users.flash.not_unassigned')"
                    :deleteId="data.id"
                    grid="table-action-cell--grid-1of1"
            ></delete-button>
        </table-actions-menu>
    </div>
</template>

<script>
    import InlineSvg from '../../../util/inlineSvg.js'
    import EditButton from '../../table_actions/table_actions_buttons/EditButton.vue';
    import DeleteButton from '../../table_actions/table_actions_buttons/DeleteButton.vue';

    export default {
        props: ['data', 'index', 'user'],

        components: {
            EditButton,
            DeleteButton,
            InlineSvg
        },
    }
</script>
